import { motion } from "framer-motion";

const BG = "https://static.prod-images.emergentagent.com/jobs/3d10772a-cb67-43bb-b3d0-4bc6c89f8f66/images/15271f6332cadc2f3b7427007f0ef9f323e5a7b0e4a82f6b07b6ee37862396ed.jpeg";
const SCALE = 1.5;
// goal mouth in container %, after background zoom
const GOAL = { x0: 12, x1: 88, y0: 23, y1: 62 };
const gx = (p) => GOAL.x0 + (GOAL.x1 - GOAL.x0) * p;
const gy = (p) => GOAL.y0 + (GOAL.y1 - GOAL.y0) * p;

export const ZONES = [
  { x: gx(0.14), y: gy(0.22) }, { x: gx(0.86), y: gy(0.22) }, { x: gx(0.5), y: gy(0.3) },
  { x: gx(0.14), y: gy(0.72) }, { x: gx(0.86), y: gy(0.72) },
];

export const PenaltyPitch = ({ shot, keeper, canAim, onAim, result }) => {
  const kz = keeper != null ? ZONES[keeper] : null;
  const diving = kz && keeper !== 2;
  const left = kz && kz.x < 50;
  const b = shot != null ? ZONES[shot] : { x: 50, y: 89 };
  return (
    <div className="relative aspect-[1264/848] rounded-3xl overflow-hidden border border-white/10 select-none bg-black" data-testid="penalty-pitch">
      <img src={BG} alt="" draggable={false} className="absolute inset-0 w-full h-full object-cover" style={{ transform: `scale(${SCALE})`, transformOrigin: "50% 62%" }} />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_100%,transparent_40%,rgba(0,0,0,0.55))]" />
      {result === "goal" && <motion.div initial={{ opacity: 0.8 }} animate={{ opacity: 0 }} transition={{ duration: 0.8 }} className="absolute inset-0 bg-white z-20 pointer-events-none" />}
      {ZONES.map((z, i) => (
        <button key={i} disabled={!canAim} onClick={() => onAim(i)} style={{ left: `${z.x}%`, top: `${z.y}%` }}
          className={`absolute z-30 -translate-x-1/2 -translate-y-1/2 w-[9%] aspect-square rounded-full border-2 transition-colors ${canAim ? "border-[#FFD700] bg-[#FFD700]/15 hover:bg-[#FFD700]/40 shadow-[0_0_18px_rgba(255,215,0,0.6)]" : "border-transparent"}`}
          data-testid={`penalty-zone-${i}`}>
          {canAim && <span className="absolute inset-[30%] rounded-full bg-[#FFD700]/70 animate-ping" />}
        </button>
      ))}
      {!diving ? (
        <motion.img src="/assets/penalty/keeper.png" alt="" draggable={false} className="absolute z-10 h-[34%] -translate-x-1/2"
          animate={{ left: "50%", top: kz ? `${GOAL.y0 - 4}%` : `${GOAL.y1 - 33}%`, scale: kz ? 1.05 : 1 }} initial={false} transition={{ duration: 0.35 }} />
      ) : (
        <motion.img src="/assets/penalty/dive.png" alt="" draggable={false} className="absolute z-10 w-[30%] -translate-x-1/2 -translate-y-1/2"
          initial={{ left: "50%", top: `${GOAL.y1 - 15}%`, rotate: 0, scaleX: left ? -1 : 1 }}
          animate={{ left: `${kz.x + (left ? 6 : -6)}%`, top: `${kz.y}%`, rotate: left ? (kz.y < 60 ? 12 : -4) : (kz.y < 60 ? -12 : 4), scaleX: left ? -1 : 1 }}
          transition={{ duration: 0.45, ease: "easeOut" }} />
      )}
      <motion.img src="/assets/penalty/ball.png" alt="" draggable={false} className="absolute z-20 w-[7%] -translate-x-1/2 -translate-y-1/2 drop-shadow-[0_8px_8px_rgba(0,0,0,0.6)]"
        initial={false} animate={{ left: `${b.x}%`, top: `${b.y}%`, scale: shot != null ? 0.5 : 1, rotate: shot != null ? 900 : 0 }}
        transition={{ duration: shot != null ? 0.5 : 0, ease: "easeOut" }} />
      {result && (
        <motion.div initial={{ scale: 0.3, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="absolute inset-0 z-40 flex items-center justify-center pointer-events-none" data-testid="penalty-result">
          <p className={`font-display font-black text-5xl sm:text-8xl tracking-tighter drop-shadow-[0_6px_0_rgba(0,0,0,0.7)] ${result === "goal" ? "gold-text" : "text-red-500"}`}>
            {result === "goal" ? "QOL!" : "XİLAS!"}
          </p>
        </motion.div>
      )}
    </div>
  );
};
